// Keeps the Recommended row loading more products as the shopper scrolls
if (!customElements.get('product-feed')) {
  class ProductFeed extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('.product-feed__grid');
      this.sentinel = this.querySelector('.product-feed__sentinel');
      this.exclude = new Set([String(this.dataset.productId)]);
      this.nextUrl = this.dataset.startUrl;
      this.loading = false;
      if (!this.list || !this.sentinel || !this.nextUrl) return;

      this.observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) this.loadMore();
      }, { rootMargin: '800px 0px' });
      this.observer.observe(this.sentinel);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    collectShownIds() {
      // Skip products already shown in the Recommended row
      const recs = this.closest('.related-products-wrapper') || document;
      recs.querySelectorAll('product-recommendations [id^="StandardCardNoMediaLink-"]').forEach((el) => {
        const id = el.id.split('-').pop();
        if (id) this.exclude.add(id);
      });
    }

    async loadMore() {
      if (this.loading || !this.nextUrl) return;
      this.loading = true;
      this.collectShownIds();
      try {
        const url = new URL(this.nextUrl, window.location.origin);
        url.searchParams.set('section_id', 'product-feed');
        const response = await fetch(url.toString());
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const page = doc.querySelector('.product-feed__page');
        if (!page) { this.finish(); return; }
        page.querySelectorAll('li[data-product-id]').forEach((item) => {
          const id = item.dataset.productId;
          if (this.exclude.has(id)) return;
          this.exclude.add(id);
          this.list.appendChild(document.importNode(item, true));
        });
        this.nextUrl = page.dataset.nextUrl || '';
        if (!this.nextUrl) this.finish();
      } catch (error) {
        this.finish();
      } finally {
        this.loading = false;
      }
      // Keep filling if the sentinel is still on screen
      if (this.nextUrl && this.sentinel.getBoundingClientRect().top < window.innerHeight + 800) {
        this.loadMore();
      }
    }

    finish() {
      this.nextUrl = '';
      if (this.observer) this.observer.disconnect();
      this.sentinel.remove();
    }
  }
  customElements.define('product-feed', ProductFeed);
}
